import useMutation from "src/hooks/useMutation";

function useOrderPrint() {
  return useMutation({
    path: `/api/v1/orders/export-print-files`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/orders`,
      shouldRevalidate: true,
    },
  });
}

export default useOrderPrint;
